import { defineStore } from "pinia";
import type { Component } from "vue";

export interface IPopover {
	comp: Component;
	// height: "25%" | "50%" | "75%" | "100%";
	props?: Record<string, any>;
	title?: string;
	header?: {
		icon: any;
		title: string;
	};
}

export const usePopoverStore = defineStore("popover", () => {
	const popoverConfig = shallowRef<IPopover | null>(null);

	const getPopover = computed<IPopover | null>(() => popoverConfig.value);

	const isVisible = computed({
		get() {
			return !!popoverConfig.value;
		},
		set(value: boolean) {
			if (!value) {
				popoverConfig.value = null;
			}
		},
	});

	function showPopover(config: IPopover) {
		popoverConfig.value = config;
	}

	function hidePopover() {
		popoverConfig.value = null;
	}

	return {
		getPopover,
		isVisible,
		showPopover,
		hidePopover,
	};
});
